export default __webpack_public_path__ + "static/media/blog.840e2a3f.png";